import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import useStyles from '../../indexcss';
import ComplaintDialog from '../../Complaint/ComplaintDialog';

const ProfileSetting = () => {
  const location = useLocation();
  const { state } = location;
  const classes = useStyles();
  const [isComplaintDialogOpen, setComplaintDialogOpen] = useState(false);

  const handleRaiseComplaintClick = () => {
    setComplaintDialogOpen(true);
  };

  const handleComplaintDialogClose = () => {
    setComplaintDialogOpen(false);
  };

  return (
    <>
      <Box className={classes.ProfileSettings}>
        <Typography className={classes.ProfileTyo}>Profile Setting</Typography>
        <Typography className={classes.typoanswerprofile}>{state?.answer}</Typography>
        <Button className={classes.profileButton} variant="contained" color="primary" onClick={handleRaiseComplaintClick}>
          Raise a Complaint
        </Button>
      </Box>
      <Box className={classes.boxmargintop}>
        <Typography className={classes.typoanswerprofile}>Step-by-step instructions for alumni interested in submitting job postings to the community.Privacy Settings:</Typography>
        <div className={classes.divprofile}>
          <Typography className={classes.typoanswerprofile}>Step 1. Accessing the Profile Section:</Typography>
          <Typography className={classes.typoanswerprofile}>1.1. SubstepSubstep SubstepSubstep 1</Typography>
          <Typography className={classes.typoanswerprofile}>1.2. Substep 2</Typography>
        </div>
      </Box>
      <ComplaintDialog open={isComplaintDialogOpen} onClose={handleComplaintDialogClose} />
    </>
  );
};

export default ProfileSetting;
